// removed by extract-text-webpack-plugin
module.exports = {"container":"_1zzwxFR7ZPzCm16FW7GuKb","content":"b5tLHI9toxhXk6Tu8tKOr","removed":"_2U2jI_w6QHMBqJ7kwndzdc"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Action/style.scss
// module id = 1248
// module chunks = 0